export default __webpack_public_path__ + "static/media/basic banking system.180fc0db.PNG";